import { GridValueFormatterParams } from '@mui/x-data-grid-pro'
import { store } from '@user/store/store'
import { selectSalesFunnelStageById } from '@user/store/salesFunnel/slice'

export const salesFunnelStageValueFormatter = ({
  value,
}: GridValueFormatterParams): any =>
  typeof value === 'number'
    ? selectSalesFunnelStageById(store.getState(), value)?.name ?? ''
    : ''
